var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 60,
    rx: 24,
    fill: "#009BE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.275 36.895H28.86C28.5567 36.895 28.405 36.755 28.405 36.475C28.405 35.005 28.685 33.6983 29.245 32.555C29.805 31.4117 30.4817 30.49 31.275 29.79C32.0683 29.09 32.8617 28.4367 33.655 27.83C35.5683 26.4067 36.525 24.9717 36.525 23.525C36.525 22.055 36.0117 20.9 34.985 20.06C33.9583 19.22 32.5233 18.8 30.68 18.8C28.86 18.8 27.4717 19.2667 26.515 20.2C25.5817 21.1333 25.1033 22.3583 25.08 23.875C25.08 24.155 24.94 24.295 24.66 24.295H22.455C22.1517 24.295 22 24.155 22 23.875C22 21.6817 22.7117 19.8267 24.135 18.31C25.5817 16.77 27.7517 16 30.645 16C33.5383 16 35.7667 16.6767 37.33 18.03C38.9167 19.3833 39.71 21.0867 39.71 23.14C39.71 24.26 39.5117 25.275 39.115 26.185C38.7183 27.0717 38.2283 27.7833 37.645 28.32C37.0617 28.8567 36.42 29.4283 35.72 30.035C35.02 30.6183 34.3783 31.1667 33.795 31.68C33.2117 32.1933 32.7217 32.87 32.325 33.71C31.9283 34.5267 31.73 35.4483 31.73 36.475C31.73 36.755 31.5783 36.895 31.275 36.895ZM31.415 39.905C31.765 40.255 31.94 40.6867 31.94 41.2C31.94 41.7133 31.765 42.145 31.415 42.495C31.065 42.8683 30.6217 43.055 30.085 43.055C29.5717 43.055 29.1283 42.8683 28.755 42.495C28.405 42.145 28.23 41.7133 28.23 41.2C28.23 40.6867 28.405 40.255 28.755 39.905C29.1283 39.5317 29.5717 39.345 30.085 39.345C30.6217 39.345 31.065 39.5317 31.415 39.905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportButton);
export default __webpack_public_path__ + "static/media/support_button.9020c3e2d028ec8412e1da094e9c595c.svg";
export { ForwardRef as ReactComponent };